import { useQuery } from "@tanstack/react-query";

import { apiLongRunningRequestTimeoutMs } from "../config";
import useApiHelper from "../hooks/useApiHelper";
import { IDashboardStatsResponse } from "../models/DashboardStats";

const staleTime = 1000 * 60 * 1; // 1 minute

export default function usePerformance(from: string, to: string, enabled = true) {
  const { get } = useApiHelper({ timeoutMs: apiLongRunningRequestTimeoutMs });

  return useQuery({
    queryKey: ["performanceStats", "range", from, to],
    queryFn: () =>
      get<IDashboardStatsResponse>(
        `/stats/range?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
      ),
    staleTime,
    enabled: enabled && !!from && !!to,
    retry: 1,
  });
}
